import React, { useRef, useContext, useState, useEffect, useCallback } from "react";
import pencil from "../../assets/pencil.png";
import { useParams, useLocation } from "react-router-dom";
import LogicContext from "../../Context/LogicContext";
import { permissionProfileService } from "../../services/permissionProfile.service";
import { createModal } from "react-modal-promise";
import GeneralModal from "../../helpers/GeneralModal";
import EditPermissionProfileModal from "../permission-profile/EditPermissionProfileModal";
import { useNavigate, useSearchParams } from "react-router-dom";





const ProfileAssignToUserDetailsPage = () => {
  const { id } = useParams();
  const logicContext = useContext(LogicContext);
  const myPromiseModal = createModal(GeneralModal);
  
  const [profileDetails, setProfileDetails] = useState({ module_list: [], profile_list: [] });
  const [profileList, setProfileList] = useState([]);
  const [selectedModuleId, setSelectedModuleId] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false); 
  const [profileId, setProfileId] = useState(null);
    const [searchParams, setSearchParams] = useSearchParams();
  
  
 const navigate = useNavigate();
  const { pathname } = useLocation();
  const printRef = useRef(null);
  const url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];



    useEffect(() => {
      if (sessionStorage.getItem('reloadPage') === 'true') {
        sessionStorage.removeItem('reloadPage');
        loadDetailsData(id);
      }
    }, []);

 

  useEffect(() => {
    document.title = "Profile Assign Details";
    loadDetailsData(id);
  }, [id]);

  const loadDetailsData = (id) => {
    permissionProfileService.profileDetailsAssignToUserDetail(id)
      .then((response) => {
        const serverData = response.data;
        console.log("serverData ", serverData);

        if (serverData) {
          setProfileDetails(serverData);
          setProfileList(serverData.profile_list || []);

         
          const moduleWithProfiles = serverData.module_list.find(module =>
            serverData.profile_list.some(p => p.module_id === module.module_id)
          );

          if (moduleWithProfiles) {
            setSelectedModuleId(moduleWithProfiles.module_id);
          } else if (serverData.module_list?.length > 0) {
            setSelectedModuleId(serverData.module_list[0].module_id);
          }
        } else {
          setProfileDetails({ module_list: [], profile_list: [] });
          setProfileList([]);
          setSelectedModuleId(null);
        }
      })
      .catch((err) => {
        console.error(err);
        setProfileDetails({ module_list: [], profile_list: [] });
        setProfileList([]);
        setSelectedModuleId(null);
      });
  };


  const editMenuAccess = (profileId) => {
    setProfileId(profileId);
    setShowEditModal(true);
  }
  

  // Filter profiles for the selected module
  const filteredProfiles = selectedModuleId
    ? profileList.filter((p) => p.module_id === selectedModuleId)
    : [];

  const selectedModuleName = profileDetails.module_list.find(
    (m) => m.module_id === selectedModuleId
  )?.module_name;

  const handlePermissionChange = useCallback((profileId, isChecked) => {
    setProfileList((prev) =>
      prev.map((p) =>
        p.profile_id === profileId
          ? { ...p, permission_status: isChecked ? "true" : "false" }
          : p
      )
    );
  }, []);







    const saveMenuAccessFromModal = useCallback(async (selectedMenuIds) => {
       const confirm = await myPromiseModal({
        title: ` ${selectedMenuIds.length  + "Menu(s) will be assigned to this profile"} `,
        body: `You are about to update ${selectedMenuIds.length} menu(s) to a new Profile`,
        showInput: false,
      });
      if (!confirm?.decision) return;
  
  
      const xmlItems = selectedMenuIds.map(menuId => `<a><menu_id>${menuId}</menu_id></a>`).join('');
  
      const payload = new FormData();
      payload.set('option', 5);
      payload.set('menu_string', `<root>${xmlItems}</root>`);
      
       
        permissionProfileService.saveProfileAssign(profileId, payload).then((res) => {
                 const cleanResponse =  logicContext.httpResponseManager(res.data?.[0] || res.data?.result_status?.[0]);
          logicContext.showToast(cleanResponse?.message_text, 'success');
          setShowEditModal(false);
          })
          .catch((err) => {
            console.error("Failed to save menu permissions", err);
          });
       
  
    }, [profileId]);




    const handleSave = useCallback(async () => {
       const confirm = await myPromiseModal({
        title: `Save user permissions for ${selectedModuleName}`,
        body: `You are about to update user permissions`,
        showInput: false,
      });
      if (!confirm?.decision) return;
  
  
      
      const xmlItems = profileList
        .map(profile => `<a><profile_id>${profile.profile_id}</profile_id></a>`)
        .join('');
  
      const payload = new FormData();
      payload.set('option', 1);
      payload.set('permission_user_id', id);
      payload.set('module_id', selectedModuleId);
      payload.set('profile_string', `<root>${xmlItems}</root>`);
      
       
        permissionProfileService.saveProfileAssignToUser( payload).then((res) => {
              console.log('result ', res.data);
                     const response = logicContext.httpResponseManager(res.data?.[0] || res.data?.result_status?.[0]);
        if (response.message_id === 1) {
          logicContext.showToast(response.message_text || 'Failed to save access!', 'success');

        } 
   })
          .catch((err) => {

       
           
          });
           }, [id]);


  const editUserProfile = () => {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new?customer_id=${id}`);
  }

  

  return (
    <section className="mt-4 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

             <div className="flex justify-end mb-2">
    <button 
      onClick={() => editUserProfile()}
      className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
    >
      <img src={pencil} alt="Edit" className="w-5 h-5" /> Edit 
    </button>
  </div>
      

  <h2 className="text-center font-bold" >Profile Assign to User Details</h2>

      <div className="flex flex-col lg:flex-row gap-8">
     
        
        {/* LEFT - Module List (Clickable) */}
        <div className="lg:w-2/5 bg-white shadow-xl rounded-xl p-6">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">Module List</h2>
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">



              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Module Name</th>
                </tr>



              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {profileDetails.module_list.map((module) => (
                  <tr
                    key={module.module_id}
                    onClick={() => setSelectedModuleId(module.module_id)}
                    className={`hover:bg-gray-50 cursor-pointer transition-colors ${
                      module.module_id === selectedModuleId ? "bg-blue-100 border-l-4 border-blue-600" : ""
                    }`}
                  >
                 
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      {module.module_name}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* RIGHT - Profiles */}
        <div ref={printRef} className="flex-1 bg-white shadow-xl rounded-xl p-6 flex flex-col">
          <h1 className="text-2xl font-bold text-gray-800 mb-2">
            {selectedModuleName ? `Profiles for: ${selectedModuleName}` : "Profile List"}
          </h1>

          {!selectedModuleId ? (
            <div className="flex-1 flex items-center justify-center text-gray-400 text-lg py-12">
              ← Click any module on the left to see profiles
            </div>
          ) : (
            <>
              <div className="overflow-x-auto flex-1">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Permission</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Profile Name</th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Action</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {filteredProfiles.map((profile) => (
                      <tr key={profile.profile_id} className="hover:bg-gray-50">
                               <td className="px-6 py-4 whitespace-nowrap">
                          <input
                  type="checkbox"
                  checked={profile.permission_status === "true" || profile.permission_status === true}
                  onChange={(e) => handlePermissionChange(profile.profile_id, e.target.checked)}
                  style={{
                    width: '20px',
                    height: '20px',
                    cursor: 'pointer',
                    accentColor: '#2563eb',
                    appearance: 'checkbox',
                    WebkitAppearance: 'checkbox',
                  }}
                />
                   
                        </td>
                    
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {profile.profile_name}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          <button
                            onClick={() => editMenuAccess(profile.profile_id)}
                            className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                          >
                            <img src={pencil} alt="Edit" className="w-5 h-5" /> Edit Menu Access
                          </button>
                        </td>
                 
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {filteredProfiles.length === 0 && (
                <div className="text-center py-12 text-gray-500">
                  No profiles found for this module.<br />
                  <span className="text-sm">Try selecting "Subscription" (Module ID 2)</span>
                </div>
              )}

              {/* Save button under profile list */}
              <div className="mt-8 flex justify-end">
                <button
                  onClick={handleSave}
                  className="flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
                >
                  <img src={pencil} alt="Save" className="w-5 h-5" />
                  Save Profile Assignments
                </button>
              </div>

            </>
          )}
        </div>
      </div>
        <EditPermissionProfileModal
            id={profileId}
              show={showEditModal}
              onHide={() => setShowEditModal(false)}
              groupedMenus={{}}
              initialSelectedIds={[]}
              onSave={saveMenuAccessFromModal}
            />
    </section>
  );
};

export default ProfileAssignToUserDetailsPage;